module.exports = __webpack_public_path__ + "img/img_assistant_img1.6ea08af0.png";